import * as Features from '../../../../../../../shared/Features';
import { getSiteName, Zentuvo } from '../../../../../../../shared/Site';
import { AuthenticatedUser } from '../../../../../../../shared/types';
import { ImageComment, ImageVersion } from '../../imagePreview/queries/use-query-edited-image';

export const SE360_RECIPIENT = 8;

export enum CommentRecipient {
    Photographer = 'photographer',
    ImageEditor = 'image-editor',
    Se360 = 'se360'
}

const RECIPIENT_TITLE_KEYS: Record<CommentRecipient, string> = {
    [CommentRecipient.Photographer]: 'image-processing/modal/comments/input-label/to-photographer',
    [CommentRecipient.ImageEditor]: 'image-processing/modal/comments/input-label/to-imageeditor',
    [CommentRecipient.Se360]: 'image-processing/modal/comments/input-label/to-se360'
};

export function getRecipientTitleKey(recipient: CommentRecipient): string {
    return RECIPIENT_TITLE_KEYS[recipient];
}

export function getCommentRecipients(comment: ImageComment): CommentRecipient[] {
    let recipients: CommentRecipient[] = [];

    if (comment.toPhotographer) {
        recipients.push(CommentRecipient.Photographer);
    }
    if (comment.toImageEditor) {
        recipients.push(CommentRecipient.ImageEditor);
    }
    if (comment.toSe360) {
        recipients.push(CommentRecipient.Se360);
    }

    return recipients;
}

export function canViewComments(user: AuthenticatedUser): boolean {
    return Features.hasAnyFeature(
        [
            Features.ViewCommentsForAll,
            Features.ViewCommentsForImageEditor,
            Features.ViewCommentsForPhotographer
        ],
        user
    );
}

export function getCommentCompanyName(siteName: string): string {
    return siteName === getSiteName(Zentuvo) ? 'Zentuvo' : 'SE360';
}

export function getImageComments(versions: ImageVersion[]): ImageComment[] {
    return versions.reduce<ImageComment[]>(
        (comments, version) =>
            comments.concat(version.commentModel ? version.commentModel.comments : []),
        []
    );
}
